import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { AdminService } from "../../../app/service/admin.service";
import { Header } from "../../../components/user-dashboard/header";
import { Sidebar } from "../../../components/user-dashboard/sidebar";
import { DataTable } from "../../../components/tables";
import { ResultListDataGridCols } from "./data-grid-cols";

const ResultList = () => {
  const [name, setName] = useState("");
  const [registersData, setRegistersData] = useState([]);
  const [filteredRegisters, setFilteredRegisters] = useState([]);

  const navigate = useNavigate();
  const { resultId } = useParams();

  useEffect(() => {
    getRegisters();
  }, []);

  const getRegisters = () => {
    AdminService.allGuestList(resultId).then((res) => {
      if (res.status === "Success") {
        setRegistersData(res.data);
        setFilteredRegisters(res.data);
      } else {
        toast.error(res.message);
      }
    });
  };

  const handleSearch = () => {
    const filteredData = registersData.filter((register:any) =>
      register.name?.toLowerCase().includes(name.toLowerCase())
    );
    setFilteredRegisters(filteredData);
  };

  const handleCancel = () => {
    setName("");
    setFilteredRegisters(registersData);
  };

  const handleBack = () => {
    navigate(-1);
  };

  const deleteRegisterInfo = (filterAccessId:any) => {
    const payload = {
      guessId: filterAccessId,
    };

    AdminService.deleteGuest(payload).then((res) => {
      if (res.status === "Success") {
        toast.success(res.message);
        getRegisters();
      } else {
        toast.error(res.message);
      }
    });
  };

  const handleEditUser = (data:any) => {
    navigate("/exam/editquestions", { state: data });
  };

  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <Header />
        </div>

        <div className="row">
          <div className="col-md-2 h-100 px-0">
            <Sidebar />
          </div>

          <div className="col-md-10 content-scroll content-bg px-3 py-3">
            {/* Back Button */}
            <div className="mb-3">
              <button
                className="btn btn-secondary"
                onClick={handleBack}
              >
                ← Back
              </button>
            </div>

            <div className="row">
              <div className="col-md-6 mt-3">
                <label className="form-label d-flex justify-content-start text-start">
                  <h5>
                    <b>Result List</b>
                  </h5>
                </label>

                <div className="d-flex">
                  <input
                    name="User Name"
                    onChange={(e) => setName(e.target.value)}
                    className="form-control mt-1 me-2"
                    value={name}
                    placeholder="Enter the Name"
                  />

                  <button
                    className="btn btn-primary rounded px-4 py-1"
                    onClick={handleSearch}
                  >
                    Search
                  </button>

                  <button
                    className="btn btn-secondary rounded ms-2 px-4 py-1"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            <div className="mt-5">
              <DataTable
                tableData={filteredRegisters}
                TableCols={ResultListDataGridCols}
                deleteRegisterInfo={deleteRegisterInfo}
                handleEditUser={handleEditUser}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResultList;